import React from "react";
import LogoDakikaNos from "../icons/Arrows/LogoDakikaNos";
import "./vendorFlow.css";
import { translateText, useTranslationSnapshot } from "./../translations/runtime";


function VendorLoadingOverlay({ label = "Loading", visible = true }) {
  useTranslationSnapshot();
  if (!visible) return null;

  return (
    <div className="vendor-loading-overlay" role="status" aria-live="polite">
      <div className="vendor-loading-panel">
        <div className="vendor-loading-logo">
          <LogoDakikaNos />
        </div>
        <div className="vendor-loading-track" aria-hidden="true">
          <span />
        </div>
        <div className="vendor-loading-label">{translateText(label)}</div>
      </div>
    </div>
  );
}

export default VendorLoadingOverlay;
